import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { Amplify } from 'aws-amplify';
import { AuthProvider } from '@/lib/auth';
import { ToastProvider } from '@/components/ui/toast';
import { loadConfig } from '@/lib/config';
import App from '@/App';
import '@/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById('root')!;
rootEl.textContent = 'Loading…';

loadConfig()
  .then((config) => {
    // In production, feed the fetched amplify_outputs.json straight to
    // Amplify so signIn / fetchAuthSession / signOut work against the
    // shared Cognito pool. In dev, loadConfig() returns null and the
    // auth.tsx stub continues to handle login until A3 swaps it out.
    if (config) {
      Amplify.configure(config);
    }
    createRoot(rootEl).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </StrictMode>,
    );
  })
  .catch((err) => {
    rootEl.textContent = `Failed to load app config: ${err instanceof Error ? err.message : String(err)}`;
  });
